import { render, staticRenderFns } from "./lizhuSettlement.vue?vue&type=template&id=1671db68&scoped=true"
import script from "./lizhuSettlement.vue?vue&type=script&lang=js"
export * from "./lizhuSettlement.vue?vue&type=script&lang=js"
import style0 from "./lizhuSettlement.vue?vue&type=style&index=0&id=1671db68&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1671db68",
  null
  
)

export default component.exports